import moment from "moment";
import { currentMonthCurrentDate } from "../../common-data/Converts";

export const validateForm = (formValues) => {
  let errors = {};

  const isDual = formValues.selectedPaymentMode?.value === "dual";
  const isPartial = formValues.selectedPaymentMode?.value === "partial";
  const isPartialAllowed = formValues.selectedPlan?.info?.is_partial;
  const isCouple = formValues.selectedPlan?.is_couple;

  const selectedAmount = Number(formValues.selectedPrice?.label || 0);

  if (!formValues.selectedGym) {
    errors.selectedGym = "Gym Is Required!";
  }

  if (!formValues.selectedPrice) {
    errors.selectedPrice = "Plan Price Is Required!";
  }

  if (!formValues.selectedSubsStartDate) {
    errors.selectedSubsStartDate = "Subscription Start Date Is Required!";
  }

  if (!formValues.selectedPlan) {
    errors.selectedPlan = "Plan Is Required!";
  }

  if (!formValues.selectedPaymentMode) {
    errors.selectedPaymentMode = "Payment Mode Is Required!";
  } else if (isPartial && !isPartialAllowed) {
    errors.selectedPaymentMode =
      "Partial Payment Is Not Allowed For This Plan!";
  }

  if (!formValues.selSourceName) {
    errors.selSourceName = "Source Name Is Required!";
  }

  if (isCouple) {
    if (!formValues.memberMobile2) {
      errors.memberMobile2 = "Required!";
    }

    if (!formValues.member2Info) {
      errors.memberMobile2 = "Required!";
    }

    if (
      formValues.memberGender &&
      formValues.memberGender2?.value &&
      formValues.memberGender === formValues.memberGender2?.value
    ) {
      // errors.memberGender = "Both members cannot have the same gender!";
      errors.memberGender2 = "Both members cannot have the same gender!";
    }
  }

  if (isDual) {
    const sumOfDualAmounts =
      Number(formValues.cashAmount || 0) + Number(formValues.onlineAmount || 0);

    if (!formValues.cashAmount) {
      errors.cashAmount = "Cash Amount Is Required!";
    } else if (Number(formValues.cashAmount) <= 0) {
      errors.cashAmount = "Cash Amount Should Be Greater Than 0!";
    }

    if (!formValues.onlineAmount) {
      errors.onlineAmount = "Online Amount Is Required!";
    } else if (Number(formValues.onlineAmount) <= 0) {
      errors.onlineAmount = "Online Amount Should Be Greater Than 0!";
    }

    if (sumOfDualAmounts !== selectedAmount) {
      errors.cashAmount = "Cash Amount + Online Amount = Selected Amount!";
      errors.onlineAmount = "Cash Amount + Online Amount = Selected Amount!";
    }
  }

  if (isPartial && isPartialAllowed) {
    const sumOfAllInstallments =
      Number(formValues.firInsAmount || 0) +
      Number(formValues.secInsAmount || 0) +
      Number(formValues.thiInsAmount || 0);

    const isFirstInstallMentDateValid = formValues.firInsDate
      ? moment(formValues.firInsDate, "YYYY-MM-DD").isBefore(
          moment(currentMonthCurrentDate, "YYYY-MM-DD")
        )
      : "";

    const isSecondInstallMentDateValid = formValues.secInsDate
      ? moment(formValues.secInsDate, "YYYY-MM-DD").isBefore(
          moment(formValues.firInsDate, "YYYY-MM-DD")
        )
      : "";

    const isThirdInstallMentDateValid = formValues.thiInsDate
      ? moment(formValues.thiInsDate, "YYYY-MM-DD").isBefore(
          moment(formValues.secInsDate, "YYYY-MM-DD")
        )
      : "";

    if (!formValues.selectedFirstPartialPaymentMode) {
      errors.selectedFirstPartialPaymentMode =
        "First Installment Payment Mode Is Required!";
    }

    if (!formValues.firInsAmount) {
      errors.firInsAmount = "First Installment Amount Is Required!";
    } else if (Number(formValues.firInsAmount) < 0) {
      errors.firInsAmount =
        "First Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (!formValues.secInsAmount) {
      errors.secInsAmount = "Second Installment Amount Is Required!";
    } else if (Number(formValues.secInsAmount) < 0) {
      errors.secInsAmount =
        "Second Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (formValues.thiInsAmount !== 0 && !formValues.thiInsAmount) {
      errors.thiInsAmount = "Third Installment Amount Is Required!";
    } else if (Number(formValues.thiInsAmount) < 0) {
      errors.thiInsAmount =
        "Third Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (sumOfAllInstallments !== selectedAmount) {
      errors.firInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
      errors.secInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
      errors.thiInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
    }

    if (!formValues.firInsDate) {
      errors.firInsDate = "First Installment Due Date Is Required!";
    } else if (isFirstInstallMentDateValid) {
      errors.firInsDate =
        "First Installment Due Date Should Be Greater Than Current Date!";
    }

    if (!formValues.secInsDate) {
      errors.secInsDate = "Second Installment Due Date Is Required!";
    } else if (isSecondInstallMentDateValid) {
      errors.secInsDate =
        "Second Installment Due Date Should Be Greater Than First Installment Date!";
    }

    if (!formValues.thiInsDate) {
      errors.thiInsDate = "Third Installment Due Date Is Required!";
    } else if (isThirdInstallMentDateValid) {
      errors.thiInsDate =
        "Third Installment Due Date Should Be Greater Than Second Installment Date!";
    }
  }

  return errors;

  // -------------------- PT FLOW --------------------
  // if (isPT && !formValues.selectedSession) {
  //   errors.selectedSession = "PT Session Is Required!";
  // }

  // if (isPT && !formValues.selectedTrainer) {
  //   errors.selectedTrainer = "Trainer Is Required!";
  // }

  // if (isPT && !formValues.selectedSlotDate) {
  //   errors.selectedSlotDate = "Slot Date Is Required!";
  // }

  // if (
  //   isPT &&
  //   formValues.selectedSlotIndex !== 0 &&
  //   !formValues.selectedSlotIndex
  // ) {
  //   errors.selectedSlot = "Trainer Slot Is Required!";
  // }

  // ---------------------- NEW PAYMENT MODE ----------------------
};
